<template>
<el-form :model="dataForm" label-position="top" ref="dataForm" class="formSearch" :rules="rules">

    <el-row  v-if="sourceType == 'out'" class="company-name">
        <el-col :span="24">
            <el-form-item  prop="customerName">
                <ab-select2
                    url="/bas/client/basCustomer/listAndAddress"
                    inputKey="nameOrNumber"
                    descKey="customerIdDesc"
                    searchKey="nameOrNumber"
                    
                    v-model="dataForm.customerName"
                    label="境外客户"
                    :urlData="{data: {principalId: this.dataForm.principalId, nameOrNumber: this.dataForm.customerName}}"
                    required
                    @handleSelect="handleCustomer"
                    @handlerAdd="handleAddCutomer"
                >
                <template v-slot:content="scope">
                    <div class="delivery-company" v-if="scope.item.customerIdDesc">
                        <div class="company">{{scope.item.customerIdDesc}} - <span class="address">{{scope.item.company}}</span></div> 
                        <div class="address">
                            <ab-svg name="dingwei"></ab-svg>
                            {{ scope.item.addressIdsName }} / {{ scope.item.linkman }} / {{ scope.item.mobile }}</div>
                    </div>
                    <div v-else style="color:#999999;text-align: center;">
                        暂无数据，可点击左侧”+“进行新增
                    </div>
                </template>
                </ab-select2>
            </el-form-item>
            <!-- <div class="receivingAddress" v-if="['02','03'].includes(this.dataForm.deliveryMethod) && (
            (dataForm.deliveryAreaNameAndContent && dataForm.deliveryAreaNameAndContent != 'undefined-undefined') || 
            (dataForm.deliveryLinkman && dataForm.deliveryLinkman != undefined) || 
            (dataForm.deliveryContactNumber && dataForm.deliveryContactNumber != undefined))
            
            ">
                <ab-svg name="dingwei" style="margin-right:5px;"></ab-svg>
               <span v-if="dataForm.deliveryCompany"> {{this.dataForm.deliveryCompany}} - </span>{{this.dataForm.deliveryAreaNameAndContent}}/{{this.dataForm.deliveryLinkman}}/{{this.dataForm.deliveryContactNumber}}
                <ab-svg style="width: 16px; height: 16px; color: #000; cursor: pointer; float: right: margin: 2px 0 0 5px;vertical-align: top;" @click="editAddress" name="edit"></ab-svg>
            </div> -->

            <div class="receivingAddress" v-if="['02','03'].includes(this.dataForm.deliveryMethod)">
                <ab-svg name="dingwei" style="margin-right:5px;"></ab-svg>
                <span v-if="dataForm.deliveryCompany"> {{this.dataForm.deliveryCompany}} - </span>{{this.dataForm.deliveryAreaNameAndContent}}/{{this.dataForm.deliveryLinkman}}/{{this.dataForm.deliveryContactNumber}}
                <ab-svg style="width: 16px; height: 16px; color: #000; cursor: pointer; float: right: margin: 2px 0 0 5px;vertical-align: top;" @click="editAddress" name="edit"></ab-svg>
            </div>
        </el-col>
    </el-row>
    <el-row :gutter="25" v-if="['02','03'].includes(dataForm.deliveryMethod) && sourceType !== 'out'" class="company-name">
        <el-col :span="24">
            <el-form-item  prop="deliveryCompany">
                <ab-select2
                    url="/bas/client/basAddress/list"
                    inputKey="companyName"
                    descKey="companyName"
                    v-model="dataForm.deliveryCompany"
                    label="收货公司"
                    :urlData="{data: {name: dataForm.deliveryCompany, addressType: '01',isEnabled: 1, principalId: this.dataForm.principalId, bizTypeGroup: '01'}}"
                    required
                    @handleSelect="handleSelect"
                    @handlerAdd="handleSelect({state: 'add'})"
                >
                <template v-slot:content="scope">
                    <div class="delivery-company" v-if="scope.item.companyName">
                        <div class="company">{{scope.item.companyName}} <span class="is-default" v-if="scope.item.isDefault">默认</span></div>
                        <div class="address">
                            <ab-svg name="dingwei"></ab-svg>
                            {{ scope.item.addressIdsName }} / {{ scope.item.linkMan }} / {{ scope.item.linkPhone }}</div>
                    </div>
                    <div v-else style="color:#999999;text-align: center;">
                        暂无数据，可点击左侧”+“进行新增
                    </div>
                </template>
                </ab-select2>
            </el-form-item>
            <div class="receivingAddress" v-if="(dataForm.deliveryAreaNameAndContent && dataForm.deliveryAreaNameAndContent != 'undefined-undefined') || (dataForm.deliveryLinkman && dataForm.deliveryLinkman != undefined) || (dataForm.deliveryContactNumber && dataForm.deliveryContactNumber != undefined)">
                <ab-svg name="dingwei"></ab-svg>
                {{this.dataForm.deliveryAreaNameAndContent}}/{{this.dataForm.deliveryLinkman}}/{{this.dataForm.deliveryContactNumber}}
                <ab-svg style="width: 16px; height: 16px; color: #000; cursor: pointer; float: right: margin: 2px 0 0 5px" @click="editAddress" name="edit"></ab-svg>
            </div>
        </el-col>
    </el-row>

    <el-row :gutter="25">
        <el-col :span="8"  :class="{'form-item-a': ['02','03'].includes(dataForm.deliveryMethod)}">
            <el-form-item   prop="deliveryMethod">
                <template #label>
                    <el-popover
                        placement="top-end"
                        popper-class="form-pop"
                        :width="300"
                        trigger="hover"
                        content="指运输方式"
                    >
                        <template #reference>
                            送货方式
                        </template>
                    </el-popover>
                </template>
                <el-popover
                    placement="top-start"
                    width="370"
                    popper-class="form-pop"
                    :disabled="dataForm.deliveryMethod != '06'"
                    trigger="hover">
                    <div class="warehouse-content"  v-if="dataForm.deliveryMethod == '06'">&nbsp; <span> 库存精细管理 </span>  &nbsp;<span>存仓7天以上 </span> &nbsp;<span>开仓租发票</span> </div>
                    <template #reference>
                        <el-select v-model="dataForm.deliveryMethod" placeholder="请选择送货方式" @change="checkedRadio">
                            <el-option :label="obj.label" :value="obj.value" :key="idx" v-for="(obj,idx) in sourceType == 'out' ? exportDeliveryMethod: importDeliveryMethod"></el-option>
                        </el-select>
                    </template>
                </el-popover>
            </el-form-item>
        </el-col>
        <!-- <el-col :span="8" :class="{'form-item-a': ['02','03'].includes(dataForm.deliveryMethod) && dataForm.deliverySignatureMode != 2}">
            <el-form-item label="送货到多个地址"  prop="deliveryIsBatchDelivery">
                <template #label>
                    <el-popover
                        placement="top-end"
                        popper-class="form-pop"
                        :width="300"
                        trigger="hover"
                        content="1个订单下的货要分别送到不同地址，提交订单后需【创建发货通知】来填写收货地址。"
                    >
                        <template #reference>
                            送货到多个地址
                        </template>
                    </el-popover>
                </template>
                <el-popover
                    placement="top-start"
                    width="370"
                    popper-class="form-pop"
                    :disabled="dataForm.deliveryIsBatchDelivery"
                    trigger="hover">
                     <div> 请提交订单后点【创建发货通知】</div>
                    <template #reference>
                        <el-select  v-model="dataForm.deliveryIsBatchDelivery" placeholder="请选择" @change="changeDelivery">
                            <el-option :label="obj.label" :value="obj.value" :key="idx" v-for="(obj,idx) in [{label: '是', value: true}, {label: '否', value: false}]"></el-option>
                        </el-select>
                    </template>
                </el-popover>
            </el-form-item>
        </el-col> -->

        <el-col :span="8" v-if="dataForm.deliveryMethod == '02'" :class="{'form-item-a': ['02','03'].includes(dataForm.deliveryMethod)}">
            <el-form-item label="签收方式"  prop="deliverySignatureMode">
                <template #label>
                    <el-popover
                        placement="top-end"
                        popper-class="form-pop"
                        :width="300"
                        trigger="hover"
                        content="签收货物的验伪方式"
                    >
                        <template #reference>
                            签收方式
                        </template>
                    </el-popover>
                </template>
                <el-select   v-model="dataForm.deliverySignatureMode" placeholder="请选择">
                    <el-option
                        v-for="item in typeList.signatureMode"
                        :key="item.value"
                        :label="item.desc"
                        :value="item.value">
                        </el-option>
                </el-select>
            </el-form-item>
        </el-col>

        <template v-if="sourceType == 'out'">
        <el-col :span="8" v-if="dataForm.deliveryMethod == '02'">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="要求送达时间" prop="deliveryTime">
                        <el-date-picker
                            size="mini"
                            v-model="dataForm.deliveryTime"
                            value-format="YYYY-MM-DD"
                            format="YYYY-MM-DD"
                            placeholder="日期"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  prop="deliveryTimeType" style="margin-top:15px;">
                        <el-select :disabled="isEdit" v-model="dataForm.deliveryTimeType" size="mini" placeholder="请选择" style="margin-top: 22px;">
                            <el-option
                                v-for="item in [{desc: '上午', value: '01'},{desc: '下午', value: '02'},{desc: '指定时间', value: '03'}]"
                                :key="item.value"
                                :label="item.desc"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-col>

        <el-col :span="8" v-if="dataForm.deliveryMethod == '02' && dataForm.deliveryTimeType == '03'">
            <el-form-item label="具体时间"  prop="deliveryTimeLabel">
                <el-time-select
                v-model="dataForm.deliveryTimeLabel"
                :disabled="isEdit"
                size="mini"
                :picker-options="{
                    start: '06:30',
                    step: '00:15',
                    end: '18:30'
                }"
                placeholder="选择时间">
                </el-time-select>
            </el-form-item>
        </el-col>
        </template>

        
        <el-col :span="8"  v-if="dataForm.deliveryMethod == '03' && !dataForm.deliveryIsBatchDelivery">
            <el-form-item label="付费方式"   prop="deliveryPayType">
                <el-select  @change="changeDeliveryPayType"   v-model="dataForm.deliveryPayType" placeholder="请选择">
                    <el-option
                    v-for="item in typeList.deliveryPayType"
                    :key="item.value"
                    :label="item.desc"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="['01'].includes(dataForm.deliveryMethod) && !dataForm.deliveryIsBatchDelivery">
            <el-form-item label="联系人"  prop="deliveryLinkman">
                <el-input size="mini" maxLength='50'  v-model="dataForm.deliveryLinkman" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="['01'].includes(dataForm.deliveryMethod) && !dataForm.deliveryIsBatchDelivery">
            <el-form-item label="联系电话"  prop="deliveryContactNumber">
                <el-input size="mini" maxLength='40'  v-model="dataForm.deliveryContactNumber" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="(dataForm.deliverySignatureMode === '2' && dataForm.deliveryMethod == '02' || dataForm.deliveryMethod == '01') && !dataForm.deliveryIsBatchDelivery" :class="{'form-item-a': ['02','03'].includes(dataForm.deliveryMethod)}">
            <el-form-item label="身份证号码：" prop="deliveryIdentityNumber">
                <ab-history v-model="dataForm.deliveryIdentityNumber"  ref="abHistory"  :historyKey="dataForm.exchangeUnitName"></ab-history>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataForm.deliveryMethod == '01'　&& !dataForm.deliveryIsBatchDelivery" :class="{'form-item-a': ['02','03'].includes(dataForm.deliveryMethod)}">
            <el-form-item label="提货公司"  prop="deliveryCompany">
                <el-input  v-model="dataForm.deliveryCompany" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataForm.deliveryMethod == '06' && sourceType != 'out'" :class="{'form-item-a': ['02','03'].includes(dataForm.deliveryMethod)}">
            <el-form-item label="仓库"  prop="inRepertoryId">
                <el-select v-model="dataForm.inRepertoryId" placeholder="请选择仓库">
                    <el-option
                    v-for="item in typeList.storehouse"
                    :key="item.id"
                    :label="item.repertoryName"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataForm.deliveryMethod == '05'">
            <el-form-item label="送达地点"  prop="deliveryLocation">
                <el-select size="mini" :disabled="isEdit" v-model="dataForm.deliveryLocation" placeholder="请选择">
                    <el-option
                    v-for="item in typeList.serviceLocation"
                    :key="item.value"
                    :label="item.desc"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataForm.deliveryMethod == '05' && ['2', '3'].includes(this.dataForm.deliveryLocation)" >
            <el-form-item label="具体名称"  prop="deliveryLocationContent">
                <el-input size="mini" :disabled="isEdit" v-model="dataForm.deliveryLocationContent" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="['2', '3'].includes(this.dataForm.deliveryLocation) && dataForm.deliveryMethod == '05'">
            <el-form-item label="订舱单号"  prop="deliveryOrderNumber">
                <el-input size="mini" :disabled="isEdit" v-model="dataForm.deliveryOrderNumber" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="sourceType == 'out' && dataForm.deliveryMethod == '02'">
            <el-form-item label="入仓号"  prop="incomingAccessionNumbers">
                <el-input size="mini" :disabled="isEdit" v-model="dataForm.incomingAccessionNumbers" maxlength="100" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>

        <template v-if="sourceType == 'out'">
        <el-col :span="8">
            <el-form-item label="运输方式" prop="transportMode" 
                :rules="[{ required: true, message: '请选择运输方式', trigger: 'change' }]"
                >
                <el-popover
                    placement="top-start"
                    width="370"
                    popper-class="form-pop"
                    content="指货物从出口报关口岸到境外目的地的运输方式"
                    trigger="hover">
                  
                    <template #reference>
                        <el-select v-model="dataForm.transportMode" placeholder="请选择运输方式" >
                            <el-option
                                v-for="item in typeList.transportModeEnum"
                                :key="item.value"
                                :label="item.desc"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </template>
                </el-popover>
            </el-form-item>
        </el-col>
        <el-col :span="8">
            <el-form-item label="运抵国/地区" prop="originCountryName" 
                :rules="[{ required: true, message: '请选择运抵国/地区', trigger: 'change' }]"
            >
                <el-popover
                    placement="top-start"
                    width="370"
                    popper-class="form-pop"
                    content="中港出口运抵国为【香港】；海运和空运出口，请填写真实的目的国"
                    trigger="hover">
                    <template #reference>
                    <ab-select
                        v-model="dataForm.originCountryName"
                        url="/bas/customsCountry/list"
                        :urlData="{ name: dataForm.originCountryName, pageNum: 1, pageSize: 10, isEnabled: 1 }"
                        inputKey="shipArriveCountryName"
                        descKey="shipArriveCountryName"
                        placeholder="运抵国/地区"
                        @handleSelect="originCountry"
                    ></ab-select>
                    </template>
                </el-popover>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataForm.transportMode == '2'">
            <el-form-item label="集装箱规格：" prop="containerMd" :rules="[{ required: this.dataForm.transportMode == '2', message: '请选择集装箱规格', trigger: 'change' }]">
                <el-select size="mini" v-model="dataForm.containerMd" :disabled="isEdit" placeholder="请选择" clearable>
                    <el-option
                    v-for="item in containerMdOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-col>
        <el-col :span="8" v-if="dataForm.transportMode == '2'" >
            <el-form-item label="船名航次：" prop="shipVoyage" :rules="[{ required: this.dataForm.transportMode == '2', message: '请选择船名航次', trigger: 'change' }]">
                <el-input size="mini" v-model="dataForm.shipVoyage" :disabled="isEdit" placeholder="请输入"></el-input>
            </el-form-item>
        </el-col>
    </template>
    </el-row>
    
    
    <ab-handlerAds :dialog="addressData" ref="handlerAds" @handlerChange="submitLinkman" @change="handlerAddress" aiParse></ab-handlerAds>
    
    <el-dialog title="修改地址信息" width="718px" v-model="editDialog.show" :before-close="editHandleClose" :close-on-click-modal='false' class="add-address-dialog">
      <el-form :model="editFormSearch" :rules="editRules" ref="editFormSearch" label-position="top">
        <el-row :gutter="30">
          <!-- <el-col :span="12">
            <el-form-item label="地址类型" prop="addressType"  class="addressType">
                <el-select  v-model="editFormSearch.addressType" disabled placeholder clearable>
                    <el-option
                        v-for="(option, idx) in typeList1.addressType"
                        :key="idx"
                        :label="option.desc"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="联系人" prop="linkMan">
              <el-input   maxLength='50' placeholder="联系人" v-model="editFormSearch.linkMan" ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系电话" prop="linkPhone">
              <el-input   maxLength='20' placeholder="联系电话" v-model="editFormSearch.linkPhone" ></el-input>
            </el-form-item>
          </el-col>
        

          <el-col :span="12">
            <el-form-item label="国家/省/市/区" prop="address">
              <ab-address v-model="editFormSearch.addressIdsDesc" @handleSelect="changeAddressDesc"></ab-address>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="详细地址" prop="addressContent">
              <el-input   v-model="editFormSearch.addressContent"  maxLength="250" placeholder="详细地址"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
             <el-form-item label="公司名称" prop="companyName">
                <el-input  v-model="editFormSearch.companyName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="地址说明" prop="addressExplain">
                <el-select   v-model="editFormSearch.addressExplain" placeholder clearable>
                    <el-option
                    v-for="(option, idx) in typeList1.addressReceive"
                    :key="idx"
                    :label="option.desc"
                    :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
             <el-form-item label="默认地址" prop="isDefault">
                <el-select  placeholder v-model="editFormSearch.isDefault">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
     <template #footer>
        <div  class="dialog-footer">
            <el-button type="primary" @click="handlerSave" :loading="editDialog.isloading">确 定</el-button>
            <el-button @click="editDialog.show = false">取 消</el-button>
        </div>
     </template>
    </el-dialog>
</el-form>
</template>

<script>
export default {
    data () {
        return {
            rules: {
                deliverySignatureMode: [{ required: true, message: '请选择签收方式', trigger: 'change'}],
                deliveryIsBatchDelivery: [{ required: true, message: '请选择是否分批送货', trigger: 'change'}],
                deliveryMethod: [{ required: true, message: '请选择交货方式', trigger: 'change'}],
                deliveryAddress: [{ required: true, message: '请选择收货公司', trigger: ['blur', 'change']}],
                deliveryIdentityNumber: [
                    { required: true, message: '身份证号码不能为空', trigger: 'blur'},
                    { validator: (rule, value, callback) => {
                        if (value && value.length != 18) {
                            callback(new Error('身份证号码长度错误'))
                        }
                        callback()
                    }, trigger: 'blur'}
                ],
                deliveryPayType: [{ required: true, message: '付费方式不能为空', trigger: 'change'}],
                deliveryCompany: [{ required: true, message: '公司不能为空', trigger: ['blur', 'change']}],
                inRepertoryId: [{ required: true, message: '仓库不能为空', trigger: ['blur', 'change']}],
                deliveryLinkman: [{ required: true, message: '联系人不能为空', trigger: 'change'}],
                deliveryContactNumber: [
                    { required: true, message: '联系电话不能为空', trigger: ['blur', 'change']},
                    { validator: (rule, value, callback) => {
                        if (value &&　!/^[0-9()\-\+\s+\/]*$/.test(value)) {
                            callback(new Error('请输入正确的联系电话'))
                        }
                        callback()
                    }, trigger: 'blur' }
                ],
                deliveryLocation: [{ required: true, message: '送达地点不能为空', trigger: 'change'}],
                deliveryLocationContent: [{ required: true, message: '具体名称不能为空', trigger: 'blur'}],
                deliveryOrderNumber: [{ required: true, message: '订舱单号不能为空', trigger: 'blur'}],
                deliveryTime: [{ required: true, message: '时间不能为空', trigger: ['blur', 'change']}],
                deliveryTimeType: [{ required: true, message: '请选择要求送货时间', trigger: 'change'}],
                deliveryTimeLabel: [{ required: true, message: '请选择具体时间', trigger: 'change'}],
                customerName: [{ required: true, message: '请选择境外客户', trigger: ['change','blue']}]
            },
            editRules: {
                linkMan: [
                    {required: true, message: '联系人不能为空', trigger: ['blur', 'change']}
                ],
                linkPhone: [
                    {required: true, message: '联系电话不能为空', trigger: ['blur', 'change']},
                    { validator: (rule, value, callback) => {
                      if (/[\u4E00-\u9FA5]/g.test(value)) {
                          callback(new Error('电话号码不能输入中文!'))
                        } else if (value.length > 200){
                          callback(new Error('最大支持200位字符长度'))
                        } else {
                          callback()
                        }
                    }, trigger: ['blur', 'change'] }
                ],
                addressIdsDesc: [
                    {required: true, message: '地址不能为空', trigger: ['blur', 'change']}
                ],
                addressContent: [
                    {required: true, message: '详细地址不能为空', trigger: ['blur', 'change']}
                ],
                addressExplain: [
                    {required: true, message: '地址说明不能为空', trigger: ['blur', 'change']}
                ],
                companyName: [
                    {required: true, message: '公司名称不能为空', trigger: ['blur', 'change']}
                ],
                isDefault: [
                    {required: true, message: '默认地址不能为空', trigger: ['blur', 'change']}
                ],
            },
            addressData: {
                type: '01',//业务类型 01 进口，02 出口
                addressType: '01',//地址类型 01收货，04发货
                isEnabled: true,
                show: false,
                addressExplain: '',
                isXplain: true
            },
            editDialog: {
                show: false,
                id: '',
                isloading: false
            },
            editFormSearch: {},
            typeList1: {
                addressReceive: [],
                addressType: []
            },
            importDeliveryMethod: [
                {label: '一咻送货', value: '02'}, 
                {label: '快递送货', value: '03'},
                {label: '自提', value: '01'},
                {label: '待通知', value: '04'},
                {label: '存仓', value: '06'}
            ],
            exportDeliveryMethod: [
                {label: '一咻送货', value: '02'}, 
                {label: '快递送货', value: '03'},
                {label: '自提', value: '01'},
                {label: '待通知', value: '04'},
                {label: '客户负责物流', value: '05'}
            ],
            templeCustomerUser: {
                linkman: '',
                mobile: ''
            },
            containerMdOption: [
                {
                    value: '07',
                    label: '20GP'
                },
                {
                    value: '08',
                    label: '40HQ'
                },
                {
                    value: '09',
                    label: '45HQ'
                }
            ],
            copyData: {},
        }
    },
    computed: {
        changeDeliveryAddress(){
            if(this.sourceType == 'out'){
                if(this.dataForm.deliveryAreaNameAndContent && this.dataForm.deliveryLinkman && this.dataForm.deliveryContactNumber){
                    return false
                }else{
                    return true
                }
            }else{
                return false
            }
        }
    },
    props: {
        dataForm: {
            type: Object
        },
        status: {
            type: Boolean,
            default: false
        },
        typeList: {
            type: Object
        },
        sourceType: {
            type: String
        }
    },
    activated(){
        this.addClientAddress()
    },
    mounted() {
        this.$post('/bas/client/basAddress/typeList').then(res => {
            if (res.data.code == 'C0000') {
                this.typeList1 = res.data.result
            }
        })
        this.addClientAddress()
    },
    methods: {
        addClientAddress(){
            let newCustomer = this.$utils.getSessionStorage('newCustomer')
            if(newCustomer && this.sourceType == 'out'){
                this.$post('/bas/client/basCustomer/listAndAddress', {
                    data: {nameOrNumber: newCustomer.name}
                }).then(({data}) => {
                    if(data.code === 'C0000') {
                        let v = data.result.list[0]
                        if (v) {//获取匹配的第一条客户地址
                            //用于编辑数据
                            this.copyData = v

                            this.dataForm.deliveryAreaId = v.areaIdDesc
                            this.dataForm.deliveryAddress = v.takeAddress
                            this.dataForm.deliveryCompany = v.company
                            this.dataForm.deliveryAreaNameAndContent = v.addressIdsName
                            this.dataForm.deliveryLinkman = v.linkman
                            this.dataForm.deliveryContactNumber = v.mobile
                        }
                    }
                })
            }
        },
        editAddress() {
            if (this.sourceType == 'out') {
                if((this.copyData && this.copyData.id) || !this.changeDeliveryAddress){
                    this.getEntryAddressList()
                }else{
                    this.editFormSearch = this.copyData
                    this.editDialog.show = true
                }
            } else {
                this.$post('/bas/client/basAddress/list', {data: {companyName: this.dataForm.deliveryCompany,name: this.dataForm.deliveryCompany, addressType: '01',isEnabled: 1, principalId: this.dataForm.principalId, bizTypeGroup: '01'}}).then(({data}) => {
                    if(data.code === 'C0000') {
                        if(!data.result.list || !data.result.list.length) {
                            this.$message.error('地址已被删除，请重新选择或前往【我的地址】维护！')
                            return
                        }
                        this.editFormSearch = data.result.list[0]
                        if(this.dataForm.deliveryContactNumber != this.editFormSearch.linkPhone || this.dataForm.deliveryLinkman != this.editFormSearch.linkMan || this.dataForm.deliveryAreaNameAndContent != this.editFormSearch.addressIdsName || this.dataForm.deliveryCompany != this.editFormSearch.companyName) {
                            delete this.editFormSearch.id
                            this.editFormSearch.linkPhone = this.dataForm.deliveryContactNumber
                            this.editFormSearch.linkMan = this.dataForm.deliveryLinkman
                            this.editFormSearch.addressIdsName = this.dataForm.deliveryAreaNameAndContent
                            this.editFormSearch.companyName = this.dataForm.deliveryCompany
                            this.editFormSearch.addressIdsDesc = this.dataForm.deliveryAreaId
                            this.editFormSearch.address = this.dataForm.deliveryAreaId
                            this.editFormSearch.addressContent = this.dataForm.deliveryAddress
                            this.editFormSearch.addressType = '01'
                            this.editFormSearch.bizTypeGroup = '01'
                        }
                        this.editDialog.show = true
                    }
                })
            }
        },
        getEntryAddressList(flag) {
            this.$post('/bas/client/basCustomer/entryAddressList', {
                customerId: this.dataForm.customerId,
                takeAddress: this.dataForm.deliveryAddress,
                linkman: this.dataForm.deliveryLinkman,
                company: this.dataForm.deliveryCompany,
                mobile: this.templeCustomerUser.mobile
            }).then(({data}) => {
                if(data.code === 'C0000') {
                    let obj = data.result.list[0]
                    if (flag) {//获取匹配的第一条客户地址
                        this.setAreadData(obj)
                    } else {
                        //修改地址
                        this.editFormSearch.linkMan = obj.linkman
                        this.editFormSearch.linkPhone = obj.mobile
                        this.editFormSearch.addressIdsDesc = obj.areaIdDesc
                        this.editFormSearch.addressContent = obj.takeAddress
                        this.editFormSearch.companyName = obj.company
                        this.editFormSearch.isDefault = obj.isDefault
                        Object.assign(this.editFormSearch, obj)
                        this.editDialog.show = true
                    }
                    
                }
            })
        },
        handlerSave() {
            this.editDialog.isloading = true
            this.editFormSearch.addressIds = this.editFormSearch.addressIdsDesc.join(',')
            let params = this.$_.cloneDeep(this.editFormSearch)
            delete params.addressIdsDesc
            let url = this.editFormSearch.id ? '/bas/client/basAddress/mod' : '/bas/client/basAddress/add'
            if (this.sourceType == 'out') {
                url = '/bas/client/basCustomer/submitLinkman'
                delete params.addressTypeDesc
                params.linkman = this.editFormSearch.linkMan
                params.mobile = this.editFormSearch.linkPhone
                params.areaIdDesc = this.editFormSearch.addressIdsDesc
                params.areaId = this.editFormSearch.addressIds
                params.takeAddress = this.editFormSearch.addressContent
                params.company = this.editFormSearch.companyName
                params.isDefault = this.editFormSearch.isDefault

            }
            
            this.$post(url, params).then(({data}) => {
                if(data.code === 'C0000') {
                    this.$message.success(data.message)
                    this.editDialog.show = false
                    console.log(this.editFormSearch, 'sssssssssssssssssss');
                    this.dataForm.deliveryAreaNameAndContent = this.editFormSearch.addressIdsName.split('-')[0] + this.editFormSearch.addressContent
                    this.dataForm.deliveryAddress = this.editFormSearch.addressContent
                    this.dataForm.deliveryLinkman = this.editFormSearch.linkMan
                    this.dataForm.deliveryContactNumber = this.editFormSearch.linkPhone
                    this.dataForm.deliveryCompany = this.editFormSearch.companyName
                }
            }).finally(() => {
                setTimeout(() => {
                    this.editDialog.isloading = false
                }, 500)
                
            })
        },
        changeAddressDesc (item, desc) {
          this.editFormSearch.addressIdsName = desc
        },
        changeDelivery () {
            this.dataForm.deliveryInfoWriteTiming = this.dataForm.deliveryIsBatchDelivery ? '02' : ''
            this.dataForm.deliveryMethod = ''
        },
        checkedRadio () {
           
           
            this.resetData()
            
            if (this.dataForm.deliveryMethod == '01') {
                this.dataForm.deliveryCompany = this.dataForm.principalName
            }
            if (this.dataForm.deliveryMethod == '03' || this.dataForm.deliveryMethod == '02') {
                if (this.sourceType == 'out') {
                    if (this.templeCustomerUser.linkman) {
                        this.dataForm.deliveryLinkman = this.templeCustomerUser.linkman
                        this.dataForm.deliveryContactNumber = this.templeCustomerUser.mobile
                    }
                    this.getBasCustomerDefualtAddress()
                } else {
                    this.getDefaultAddress()
                }
            }
            if (this.dataForm.deliveryMethod == '02') {
                var dateTime = new Date()
                dateTime = dateTime.setDate(dateTime.getDate() + 1)
                dateTime = new Date(dateTime)
                this.dataForm.deliverySignatureMode= '1'
                this.dataForm.deliveryTimeType = '01'
                this.dataForm.deliveryTime = dateTime.getFullYear() + '-' + (dateTime.getMonth() + 1) + '-' + dateTime.getDate() + ' 00:00:00'
            }
            this.$emit('setUploadParams')
        },
        resetData () {
            this.dataForm.deliveryTime = ''
           
            
            //切换交货方式 出口的供应链送货，快递送货不清空 公司地址联系人
            if (this.sourceType == 'out') {
                if (!['02','03'].includes(this.dataForm.deliveryMethod)) {
                    this.dataForm.deliveryLinkman = ''
                    this.dataForm.deliveryContactNumber = ''
                    this.dataForm.deliveryAreaId = []
                    this.dataForm.deliveryAddress = ''
                    this.dataForm.deliveryCompany = ''
                    this.dataForm.deliveryAreaNameAndContent = ''
                }
            } else {
                this.dataForm.deliveryLinkman = ''
                this.dataForm.deliveryContactNumber = ''
                this.dataForm.deliveryAreaId = []
                this.dataForm.deliveryAddress = ''
                this.dataForm.deliveryCompany = ''
                this.dataForm.deliveryAreaNameAndContent = ''
            }
            this.dataForm.deliverySignatureMode = ''
            this.dataForm.deliveryIdentityNumber = ''
            this.dataForm.deliveryMonthlyAccounts = ''
            this.dataForm.deliveryFastMailCompany = ''
            this.dataForm.deliveryFastMailCompanyContent = ''
            this.dataForm.deliveryRemark = ''
            this.dataForm.deliveryPayType = ''
            this.dataForm.deliveryLocation = ''
            this.dataForm.deliveryLocationContent = ''
            this.dataForm.deliveryOrderNumber = ''
        },
        getBasCustomerDefualtAddress () {
            if (this.dataForm.customerId) {
                //读取默认地址
                this.$post('/bas/client/basCustomer/getDefaultAddress', {isEnabled: 1, customerId: this.dataForm.customerId}).then(res => {
                    if (res.data.code === 'C0000' && res.data.result) {
                        this.setAreadData(res.data.result)
                    } else {
                        this.getEntryAddressList(true)
                    }
                })
            }
        },
        setAreadData (item) {
            this.dataForm.deliveryAreaId = item.areaIdDesc
            this.dataForm.deliveryAddress = item.takeAddress
            this.dataForm.deliveryLinkman = item.linkman
            this.dataForm.deliveryContactNumber = item.mobile
            this.dataForm.deliveryCompany = item.company
            this.dataForm.deliveryAreaNameAndContent = item.addressIdsName
        },
        getDefaultAddress () {
            let data = {addressType: '01', isEnabled: 1, principalId: this.dataForm.principalId, bizTypeGroup: '01'}
            this.$post('/bas/client/basAddress/getDefaultAddress', {data}).then(res => {
                if (res.data.code === 'C0000' && res.data.result) {
                    let item = res.data.result
                    this.dataForm.deliveryAreaId = item.addressIdsDesc
                    this.dataForm.deliveryAddress = item.addressContent
                    this.dataForm.deliveryLinkman = item.linkMan
                    this.dataForm.deliveryContactNumber = item.linkPhone
                    this.dataForm.deliveryCompany = item.companyName
                    this.dataForm.deliveryAreaNameAndContent = item.addressIdsName
                }
            })
        },
        handleSelect (item) {
            console.log(item)
            if (item.state == 'add') {
                if(!this.dataForm.customerId) {
                    this.$message({
                        type: 'error',
                        message: '下游客户不存在!',
                        offset: 380,
                        grouping: true,
                    })
                    return
                }
                this.addressData.companyName = this.dataForm.customerName
                if (this.sourceType == 'out') {
                    this.addressData.addressType = '01'
                    this.addressData.isReset = true
                }
                this.addressData.isDefaultAdd = true
                this.addressData.show = true
            } else {
                if (this.sourceType == 'out') {
                    this.setAreadData(item)
                } else {
                    this.dataForm.deliveryAreaId = item.addressIdsDesc
                    this.dataForm.deliveryAddress = item.addressContent
                    this.dataForm.deliveryAreaNameAndContent = item.addressIdsName
                    this.dataForm.deliveryLinkman = item.linkMan
                    this.dataForm.deliveryContactNumber = item.linkPhone
                    this.dataForm.deliveryCompany = item.companyName
                }
            }
        },
        submitLinkman (item) {
            this.$refs.handlerAds.isloading = true
            this.$post('/bas/client/basCustomer/submitLinkman', 
                {
                    parentId: this.dataForm.customerId,
                    linkman: item.linkMan,
                    company: item.companyName,
                    mobile: item.linkPhone,
                    takeAddress: item.addressContent,
                    areaId: item.address.join(','),
                    addressDescription: item.addressExplain,
                    isDefault: item.isDefault,
                    addressType: "01",
                    bizType: "03"
                }).then(({data}) => {
                if (data && data.code == 'C0000') {
                    console.log(item)
                    this.$refs.handlerAds.isloading = false
                    this.dataForm.deliveryAreaId = item.address
                    this.dataForm.deliveryAreaNameAndContent = item.addressIdsName
                    this.dataForm.deliveryAddress = item.addressContent
                    this.dataForm.deliveryLinkman = item.linkMan
                    this.dataForm.deliveryContactNumber = item.linkPhone
                    this.dataForm.deliveryCompany = item.companyName
                    this.$refs.handlerAds.handleClose()
                }
            })
        },
        handlerAddress (item) {
            console.log(item)
            this.dataForm.deliveryAreaId = item.address
            this.dataForm.deliveryAreaNameAndContent = item.areaDesc + '-' + item.addressContent
            this.dataForm.deliveryAddress = item.addressContent
            this.dataForm.deliveryLinkman = item.linkMan
            this.dataForm.deliveryContactNumber = item.linkPhone
            this.dataForm.deliveryCompany = item.companyName
        },
        changeDeliveryPayType () {
            //当付费方式=到付（单结）和寄付（月结），月结账户不可填 ,先清空
           if (this.dataForm.deliveryPayType == '2' || this.dataForm.deliveryPayType == '3') {
               this.dataForm.deliveryMonthlyAccounts = ''
           }
        },
        validate () {
            return new Promise((resolve, reject) => {
                this.$refs.dataForm.validate((valid, fields) => {
                    if (valid) {
                        return resolve(this.dataForm)
                    } else {
                        reject(fields)
                    }
                })
            })
        },
        handleCustomer (v) {
            if (v.id || v.customerId) {
                this.copyData = v

                this.dataForm.customerId = v.customerId
                this.dataForm.customerName = v.customerIdDesc
                this.dataForm.deliveryAreaId = v.areaIdDesc
                this.dataForm.deliveryAddress = v.takeAddress
                this.dataForm.deliveryCompany = v.company
                this.dataForm.deliveryAreaNameAndContent = v.addressIdsName
                this.dataForm.deliveryLinkman = v.linkman
                this.dataForm.deliveryContactNumber = v.mobile
               
                this.templeCustomerUser.linkman = v.linkman
                this.templeCustomerUser.mobile = v.mobile
            }else{
                this.copyData = {}

                this.dataForm.customerId = undefined
                this.dataForm.customerName = undefined
                this.dataForm.deliveryAreaId = undefined
                this.dataForm.deliveryAddress = undefined
                this.dataForm.deliveryCompany = undefined
                this.dataForm.deliveryAreaNameAndContent = undefined
                this.dataForm.deliveryLinkman = undefined
                this.dataForm.deliveryContactNumber = undefined

                this.templeCustomerUser.linkman = undefined
                this.templeCustomerUser.mobile = undefined
            }
            if (this.dataForm.incomingMethod == '01' || this.dataForm.incomingMethod == '04') {
                this.$emit('getDefaultAddress')
            }
        },
        originCountry (v) {
            if (!v.id) {
                this.dataForm.originCountryName = ''
                this.dataForm.originCountryId = ''
            } else {
                this.dataForm.originCountryName = v.shipArriveCountryName
                this.dataForm.originCountryId = v.id
            }
        },
        handleAddCutomer () {
            this.$utils.setSessionStorage('isNewCustomer', {isNewCustomer: true})
            this.$router.push({
                path: '/client-detail',
                query: {
                    action: 'detail',
                    cache: false,
                    returnPath: '/export-orders-detail'
                }
            })
        }
    }
}
</script>

<style lang="scss">
.warehouse-content{
    padding: 10px;
    span{
        position: relative;
        text-indent: 1em;
        padding-left: 8px;
        &::before{
            position: absolute;
            top: 6px;
            left: 0;
            content: '';
            width: 4px;
            height: 4px;
            background-color: #0b7aff;
            border-radius: 50%;
        }
    }
    
}
.company-name .el-form-item{
    margin-bottom: 20px!important;
}
.delivery-company {
    padding-bottom: 10px;
    .company:first-child {
        padding-top: 10px;
    }
    .address {
        line-height: 20px;
        color:#999999;
        .icon-svg {
            width: 11px;
            height: 16px;
            vertical-align: bottom;
        }
    }
    .company {
        line-height: 20px;
    }
    .is-default {
        color: #F87243;
        display: inline-block;
        background-color: #FEEAE3;
        padding: 3px;
        border-radius: 8px;
    }
    
}
</style>